/* eslint-disable complexity, sonarjs/cognitive-complexity, react/jsx-boolean-value, id-match */
import { faBed, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { useSelector } from 'react-redux';
import { Element, scroller } from 'react-scroll';
import { HOTEL_URL_PARAMS } from '../../../../config/constants/google-hotel-ads';
import { MODALS } from '../../../../config/constants/lightbox';
import COOKIES from '../../../../config/cookies/cookies';
import { CALENDAR_STEP_TWO } from '../../../../config/setup/setup';
import {
  BOOKING_STEP_ONE,
  BOOKING_STEP_TWO,
  BOOKING_STEP_THREE,
  CYF_BOOKING_STEP_ONE,
  CYF_BOOKING_STEP_TWO,
  CYF_BOOKING_STEP_THREE,
  CYF_BOOKING_STEP_FOUR,
  CYF_BOOKING_STEP_FIVE,
  CYF_BOOKING_STEP_SIX,
  CYF_BOOKING_STEP_SIX_A,
  CHOOSE_ARRIVAL,
  CM_CHOOSE_DATES,
  CM_CHOOSE_CHECKOUT_DATE,
  DEPOSIT_AVAILABLE,
  FLIGHT_ERROR,
  USE_ORIGINAL_FLIGHT,
  GIVE_AS_A_GIFT,
  BCOR_GIFT_MESSAGE,
  CM_STEP_ONE,
  CM_STEP_TWO,
  CM_STEP_THREE,
  CM_GIFT_STEP_ONE,
  NO_PRODUCTS,
  NO_PRODUCTS_FOR_NIGHTS,
  CM_CHOOSE_PRODUCT,
  VIP_CALENDAR_SOCIAL_CUE,
  VIP_FIFTEEN_PERCENT,
  VIP_CHECKOUT,
} from '../../../../config/text/text';
import {
  addOneDayToCheckinDate,
  checkIsSameDayLastAvailable,
  checkIsSameOrBefore,
  convertBookingProductToBasketProduct,
  dateCalculateNights,
  dateConvertAvailToProduct,
  dateConvertSlashToDash,
  DDMMYYSlashFormat,
  DDMMYYYYDashFormat,
  formatFlightsForBasket,
  getDefaultFlightForDate,
  getMonth,
  getProductsForDateNew,
  getYear,
  isDatesValid,
  MAX_NIGHTS_DEFAULT,
  useAvailability,
} from '../../../../helpers/booking';
import { isLightPage } from '../../../../helpers/browser';
import {
  CalendarBuyButtons,
  getBuyButtonDeal,
  TravelCalendarBuyButtons,
} from '../../../../helpers/calendar';
import useCheckMobile from '../../../../helpers/checkMobile';
import { formatCurrency } from '../../../../helpers/currency';
import { isBookingCalendarOnRedemptionGiftDeal } from '../../../../helpers/deals';
import ErrorTrackingService from '../../../../helpers/errorTrackingService';
import ThemeContext from '../../../../providers/ThemeProvider';
import Message, { MESSAGE_TYPES } from '../../../_generic/Message';
import BasketSocialCues from '../../../checkout/BasketSocialCues';
import DealGiftButton from '../buy-buttons/DealGiftButton';
import ExpressCheckoutText from '../buy-buttons/ExpressCheckoutText';
import BookingAlternativeFlights from './BookingAlternativeFlights';
import BookingCalendar from './BookingCalendar';
import BookingCalendarAirports from './BookingCalendarAirports';
import BookingCalendarClear from './BookingCalendarClear';
import BookingCalendarNights from './BookingCalendarNights';
import BookingCalendarPackages from './BookingCalendarPackages';
import BookingCalendarPassengers from './BookingCalendarPassengers';
import BookingCalendarPayments from './BookingCalendarPayments';
import BookingCalendarPrice from './BookingCalendarPrice';
import BookingCalendarProducts from './BookingCalendarProducts';
import BookingCalendarRoomOnlyPackages from './BookingCalendarRoomOnlyPackages';
import BookingCalendarStep from './BookingCalendarStep';
import CalendarSocialCue from './CalendarSocialCue';
import ChannelManagerNights from './ChannelManagerNights';
import FlightPair from './FlightPair';

const CalendarContainer = ({
  deal,
  isCYF,
  isGift,
  isModal = false,
  isDynamicTravelDeal = false,
  isGoogleHotel = false,
  isTravel = false,
  setIsOptionSelected = () => {},
  buttonRef = undefined,
  mainDealGiftButton,
  searchParams,
  setIsCYOSelected,
  buyButton = null,
  isExpressDealPage = false,
  paymentData = null,
  setIsExpressPayLoaded,
  isExpressPayLoaded = false,
  isNibbleAppeared = false,
  setIsNibbleAppeared,
  isModernVipVariant,
}) => {
  const theme = useContext(ThemeContext);
  const isMobile = useCheckMobile(false);
  let initialReadyForCalendar = true;
  let initialQuantity = deal.pricePerPerson ? 2 : 1;
  if (isCYF) {
    initialReadyForCalendar = false;
    initialQuantity = 2;
  }
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [error, setError] = useState(false);
  const [flightError, setFlightError] = useState(false);
  // selection
  const [dateSelection, setDateSelection] = useState(null);
  const initialDates = isDynamicTravelDeal
    ? {
        checkInDate: null,
        checkOutDate: null,
      }
    : null;
  const [beginEndDates, setBeginEndDates] = useState(initialDates);
  const [dynamicTravelError, setDynamicTravelError] = useState('');
  // CYF will need quantity(passengers) departureAirport and nights to be ready
  const [isReadyForCalendar, setIsReadyForCalendar] = useState(
    initialReadyForCalendar,
  );
  const [quantity, setQuantity] = useState(() => initialQuantity);
  const [departureAirport, setDepartureAirport] = useState('');
  const [nights, setNights] = useState('');
  const [thisDealLondonAirports, setThisDealLondonAirports] = useState(null);
  const [deposit, setDeposit] = useState(() => deal.depositAvailable);
  const [products, setProducts] = useState(null);
  const [packages, setPackages] = useState(null);
  const [roomOnly, setRoomOnly] = useState(null);
  const [selection, setSelection] = useState(null);
  const [flights, setFlights] = useState(null);
  const [defaultFlights, setDefaultFlights] = useState(null);
  const [inBoundDate, setInBoundDate] = useState(null);
  const [priceDiff, setPriceDiff] = useState(0);
  const isBookingCalendarOnRedemptionGift = isBookingCalendarOnRedemptionGiftDeal(
    deal,
  );
  const [isDynamicTravelGift, setIsDynamicTravelGift] = useState(false);

  const [maxNights, setMaxNights] = useState(null);
  const [currentLastSelectableDate, setCurrentLastSelectableDate] = useState(
    null,
  );
  const [currentLastAvailableStay, setCurrentLastAvailableStay] = useState(
    null,
  );
  const [nextDayCellIndex, setNextDayCellIndex] = useState(null);
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [currentHoverDate, setCurrentHoverDate] = useState(null);
  const [isMouseLeftCalendar, setIsMouseLeftCalendar] = useState(true);
  const [key, setKey] = useState(
    isGoogleHotel && roomOnly?.length > 0 ? 'roomonly' : 'packages',
  );
  const [showTabHeader, setShowTabHeader] = useState(
    roomOnly?.length > 0 && packages?.length > 0,
  );
  const [cmAdNights, setCmAdNights] = useState(1);

  useEffect(() => {
    if (isExpressDealPage) {
      if (!selection && typeof setIsExpressPayLoaded === 'function')
        setIsExpressPayLoaded(false);
      else if (
        !isExpressPayLoaded &&
        selection !== null &&
        typeof setIsExpressPayLoaded === 'function'
      )
        setIsExpressPayLoaded(true);
    }
  }, [selection]);

  let STEP_A = BOOKING_STEP_ONE;
  let STEP_B = BOOKING_STEP_TWO;
  let STEP_C = BOOKING_STEP_THREE;
  if (isCYF) {
    STEP_A = CYF_BOOKING_STEP_FOUR;
    STEP_B = CYF_BOOKING_STEP_FIVE;
    STEP_C = CYF_BOOKING_STEP_SIX;
  }
  if (isDynamicTravelDeal) {
    STEP_A = isDynamicTravelGift ? CM_GIFT_STEP_ONE : CM_STEP_ONE;
    STEP_B = CM_STEP_TWO;
    STEP_C = CM_STEP_THREE;
  }

  const setRoomOnlyTab = (tabKey) => {
    setKey(tabKey);
    if (tabKey === 'packages' && packages?.length > 0) {
      // select the first package
      const newPackage = packages[0].calendarProductView[0];
      setSelection(newPackage);
      setIsOptionSelected(true);
    } else if (tabKey === 'roomonly' && roomOnly?.length > 0) {
      const urlProductId = searchParams.get(HOTEL_URL_PARAMS.product_id);
      let newRoomOnlySelection;
      if (urlProductId) {
        // if the product id in url is in the list select that one
        newRoomOnlySelection = roomOnly.find(
          (product) =>
            product.dealVoucherProductId === Number.parseInt(urlProductId, 10),
        );
      }
      if (!newRoomOnlySelection) {
        // select the first package as default
        newRoomOnlySelection = roomOnly[0];
      }

      setSelection(newRoomOnlySelection);
      setIsOptionSelected(true);
    } else {
      setSelection(null);
      setIsOptionSelected(false);
    }
  };

  const onChooseOriginalFlight = () => {
    setFlights(defaultFlights);
    setPriceDiff(Number.parseFloat(defaultFlights.priceDiff));
  };

  const onChooseFlight = (flightPair) => {
    // choosing an alternative flight
    const formattedFlights = formatFlightsForBasket(flightPair);
    setFlights(formattedFlights);
    // priceDiff will modify the price, show at the bottom and in product
    setPriceDiff(Number.parseFloat(formattedFlights.priceDiff));
  };

  const getIncludedFlight = async () => {
    const newFlights = await getDefaultFlightForDate(
      dateSelection,
      selection.dealVoucherProductId,
    );
    if (newFlights?.departureAirport && newFlights?.arrivalAirport) {
      const formattedFlights = formatFlightsForBasket(newFlights);
      setFlights(formattedFlights);
      setDefaultFlights(formattedFlights);
      setInBoundDate(formattedFlights.inbound.departureTime);
      setPriceDiff(Number.parseFloat(formattedFlights.priceDiff));
      setFlightError(false);
    } else {
      setFlightError(true);
    }
  };

  const getProducts = async (
    date,
    checkIn,
    checkOut,
    isDynamicGift,
    newNights,
    // eslint-disable-next-line max-params
  ) => {
    const {
      newMaxNights,
      newPackages,
      newProducts,
      newRoomOnly,
    } = await getProductsForDateNew(
      deal,
      date,
      quantity,
      departureAirport,
      newNights ? newNights : nights,
      isReadyForCalendar,
      thisDealLondonAirports,
      isDynamicTravelDeal,
      isDynamicGift,
      dateConvertSlashToDash(checkIn) ||
        dateConvertSlashToDash(beginEndDates?.checkInDate),
      dateConvertSlashToDash(checkOut) ||
        dateConvertSlashToDash(beginEndDates?.checkOutDate),
      isGoogleHotel,
      searchParams,
    );
    if (newProducts) {
      // existing flow
      setProducts(newProducts);
      // select first available product as default
      const firstProduct = newProducts.find(
        (product) => product.productAvailable,
      );
      setSelection(firstProduct);
      setIsOptionSelected(true);
    }

    // Ideally add some loaders for gifting UI
    if (
      !isDynamicGift ||
      (isDynamicGift && newMaxNights?.includes(Number.parseInt(newNights, 10)))
    ) {
      setPackages(newPackages);
    }

    if (newPackages) {
      // dynamic travel deal flow

      // select first available product as default
      // select the first package
      const firstPackage = newPackages[0]?.calendarProductView;
      if (firstPackage && firstPackage.length > 0) {
        const firstProduct = firstPackage.find(
          (product) => product.productAvailable,
        );
        setSelection(firstProduct);
      }

      if (
        newMaxNights &&
        Array.isArray(newMaxNights) &&
        newMaxNights.length > 0
      ) {
        setMaxNights(newMaxNights);
      } else {
        setMaxNights(MAX_NIGHTS_DEFAULT);
      }
    }

    setRoomOnly(newRoomOnly);
    if (newRoomOnly && newRoomOnly?.length > 0) {
      // room pnly for referral from google hotel ads

      const urlProductId = searchParams.get(HOTEL_URL_PARAMS.product_id);
      let newRoomOnlySelection;
      if (urlProductId) {
        // if the product id in url is in the list select that one
        newRoomOnlySelection = newRoomOnly.find(
          (product) =>
            product.dealVoucherProductId === Number.parseInt(urlProductId, 10),
        );
      }
      if (!newRoomOnlySelection) {
        // select first available product as default
        newRoomOnlySelection = newRoomOnly.find(
          (product) => product.productAvailable,
        );
      }
      if (isGoogleHotel) {
        setSelection(newRoomOnlySelection);
      }
      setIsOptionSelected(true);
    }

    if (!isModal) {
      scroller.scrollTo(CALENDAR_STEP_TWO, {
        delay: 100,
        duration: 1_000,
        smooth: true,
      });
    } else if (isModal) {
      try {
        scroller.scrollTo(CALENDAR_STEP_TWO, {
          containerId: MODALS.dealAvailability,
          delay: 100,
          duration: 500,
          smooth: true,
        });
      } catch (error_) {
        console.warn(error_);
        ErrorTrackingService.logError(error_);
      }
    }
  };

  const selectProduct = (product) => {
    if (product) {
      setSelection(product);
      setIsOptionSelected(true);
    }
  };

  const buyButtonDeal = getBuyButtonDeal({
    convertBookingProductToBasketProduct,
    deal,
    deposit,
    flights,
    quantity,
    selection,
  });

  const setCurrentLondonAirports = (londonAirports) => {
    if (isCYF) setThisDealLondonAirports(londonAirports);
  };

  const selectAirport = (newAirportCode) => {
    if (isCYF) {
      setDateSelection(null);
      setSelection(null);
      setIsOptionSelected(false);
      setFlights(null);
      setDefaultFlights(null);
      setDepartureAirport(newAirportCode);
    }
  };

  const selectNights = (newNights) => {
    if (isCYF) {
      setDateSelection(null);
      setSelection(null);
      setIsOptionSelected(false);
      setFlights(null);
      setDefaultFlights(null);
      setNights(newNights);
    }
    if (isDynamicTravelGift) {
      getProducts('', '', '', true, newNights.toString());
      setNights(newNights.toString());
    }
  };

  const selectQuantity = (newQuantity) => {
    if (isCYF) {
      setDateSelection(null);
      setSelection(null);
      setIsOptionSelected(false);
      setFlights(null);
      setDefaultFlights(null);
    }
    setQuantity(Number.parseInt(newQuantity, 10));
  };

  const selectEndDate = (date) => {
    // isDynamicTravelDeal only for nights - +
    if (isDynamicTravelDeal && dateSelection) {
      // first date had been selected, second click will choose end date
      // setCurrentLastSelectableDate(null);
      const newDates = {
        ...beginEndDates,
        checkOutDate: dateConvertAvailToProduct(date),
      };
      setBeginEndDates(newDates);
      getProducts(
        date,
        beginEndDates.checkInDate,
        dateConvertAvailToProduct(date),
      );
      setSelection(null);
      setIsOptionSelected(false);
    }

    setError(false);
  };

  const handleLastAvailableDate = (currentLastAvailableStay, date) => {
    // if this date matches lastAvailableStay auto select the next day as checkout
    if (checkIsSameDayLastAvailable(currentLastAvailableStay, date)) {
      const newCheckoutDate = addOneDayToCheckinDate(date);
      const newDates = {
        ...beginEndDates,
        checkInDate: dateConvertAvailToProduct(date),
        checkOutDate: dateConvertAvailToProduct(newCheckoutDate),
      };
      setBeginEndDates(newDates);
      // both dates are selected, get products
      getProducts(
        date,
        dateConvertAvailToProduct(date),
        dateConvertAvailToProduct(newCheckoutDate),
      );
    }
  };

  // call to get cells
  const {
    cells,
    next,
    prev,
    displayMonth,
    displayYear,
    errorCells,
    lastAvailableStay,
    lastSelectableDate,
    lastSelectableDateFormatted,
    isCheckinNearMonthEnd,
  } = useAvailability(
    deal,
    month,
    year,
    selection,
    quantity,
    departureAirport,
    nights,
    isReadyForCalendar,
    thisDealLondonAirports,
    false,
    beginEndDates,
    currentHoverDate,
    isMouseLeftCalendar,
    isGoogleHotel,
  );

  const handleSetNextDay = (cellIndex) => {
    if (cells && cells[cellIndex + 1]) {
      // set next days cellIndex for auto select
      setNextDayCellIndex(cellIndex + 1);
    } else {
      setNextDayCellIndex(null);
    }
  };

  const selectDate = ({ date, cellIndex }) => {
    if (isDynamicTravelDeal) {
      if (dateSelection) {
        if (beginEndDates.checkInDate && beginEndDates.checkOutDate) {
          // both dates have been selected, click will choose first date again
          // reset lastSelectableDate
          // setCurrentLastSelectableDate(null);
          const newDates = {
            ...initialDates,
            checkInDate: dateConvertAvailToProduct(date),
          };
          setBeginEndDates(newDates);
          // reset the products as only checkin is selected now
          setPackages(null);
          // if this date matches lastAvailableStay auto select the next day as checkout
          handleLastAvailableDate(lastAvailableStay, date);
          handleSetNextDay(cellIndex);
        } else if (
          checkIsSameOrBefore(
            date,
            DDMMYYYYDashFormat,
            beginEndDates.checkInDate,
            DDMMYYSlashFormat,
          )
        ) {
          // one date selected, make the new selection first date
          const newDates = {
            ...beginEndDates,
            checkInDate: dateConvertAvailToProduct(date),
          };
          setBeginEndDates(newDates);
          handleSetNextDay(cellIndex);
        } else {
          // first date had been selected, second click will choose end date
          const newDates = {
            ...beginEndDates,
            checkOutDate: dateConvertAvailToProduct(date),
          };
          setBeginEndDates(newDates);
          // both dates selected, get products
          getProducts(
            date,
            beginEndDates.checkInDate,
            dateConvertAvailToProduct(date),
          );
        }

        // getProducts(date);
        setSelection(null);
        setIsOptionSelected(false);
      } else {
        setDateSelection(date);
        const newDates = {
          ...beginEndDates,
          checkInDate: dateConvertAvailToProduct(date),
        };
        setBeginEndDates(newDates);

        // if this date matches lastAvailableStay auto select the next day as checkout
        handleLastAvailableDate(lastAvailableStay, date);
        handleSetNextDay(cellIndex);
        // getProducts(date);
        setSelection(null);
        setIsOptionSelected(false);
      }
    } else {
      setDateSelection(date);
      getProducts(date);
      setSelection(null);
      setIsOptionSelected(false);
      if (isCYF) {
        setFlights(null);
        setDefaultFlights(null);
        setFlightError(false);
      }
    }

    setError(false);
  };

  const onSelectProduct = (product) => {
    if (product?.dealVoucherProductId !== selection?.dealVoucherProductId) {
      selectProduct(product);
    }
  };

  const onReset = () => {
    setBeginEndDates(initialDates);
    setDateSelection(null);
    setSelection(null);
    setIsOptionSelected(false);
    setRoomOnly(null);
    setPackages(null);
    // setCurrentLastSelectableDate(null);
    if (isCYF) {
      setFlights(null);
      setDefaultFlights(null);
      setFlightError(false);
    }
    if (!isCYF) {
      setQuantity(initialQuantity);
      setFlightError(false);
    }
    setError(false);
  };

  const isButtonClickValid = () => {
    // possible auto selecting of checkout date
    if (
      isDynamicTravelDeal &&
      !isDynamicTravelGift &&
      beginEndDates.checkInDate &&
      !beginEndDates.checkOutDate &&
      nextDayCellIndex &&
      cells &&
      cells[nextDayCellIndex] &&
      cells[nextDayCellIndex].isSelectable
    ) {
      const endDate = cells[nextDayCellIndex].key;
      // set new checkout date
      const newDates = {
        ...beginEndDates,
        checkOutDate: dateConvertAvailToProduct(endDate),
      };
      setBeginEndDates(newDates);
      // get products
      getProducts(
        endDate,
        beginEndDates.checkInDate,
        dateConvertAvailToProduct(endDate),
      );
      setSelection(null);
      setIsOptionSelected(false);

      return false;
    }

    if (
      (dateSelection === null && !isDynamicTravelGift) ||
      !buyButtonDeal ||
      (isCYF && flights === null) ||
      (isDynamicTravelDeal && !selection)
    ) {
      setError(true);

      return false;
    }

    return true;
  };

  useEffect(() => {
    if (selection && isCYF) {
      getIncludedFlight();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (setIsCYOSelected) {
      setIsCYOSelected(true);
    }
  }, [selection]);

  useEffect(() => {
    if (isCYF && departureAirport !== '' && nights !== '') {
      setIsReadyForCalendar(true);
    }
  }, [isCYF, departureAirport, nights, thisDealLondonAirports]);

  useEffect(() => {
    if (isDynamicTravelDeal && isGift) {
      setIsDynamicTravelGift(true);
      getProducts('', '', '', true, '1');
    } else {
      setIsDynamicTravelGift(false);
    }
  }, [isDynamicTravelDeal, isGift]);

  useEffect(() => {
    setKey(isGoogleHotel && roomOnly?.length > 0 ? 'roomonly' : 'packages');
    setShowTabHeader(roomOnly?.length > 0 && packages?.length > 0);
  }, [roomOnly, packages]);

  useEffect(() => {
    if (isGoogleHotel && searchParams) {
      // if we have dates set them
      const newCheckInDash = searchParams.get(HOTEL_URL_PARAMS.arrival);
      const newCheckOutDash = searchParams.get(HOTEL_URL_PARAMS.departure);
      // need to set month and year on the calendar from dates in url
      if (newCheckInDash) {
        setMonth(getMonth(newCheckInDash, DDMMYYYYDashFormat) + 1);
        setYear(getYear(newCheckInDash, DDMMYYYYDashFormat));
      }

      // date validity
      const isCheckInCheckOutValid = isDatesValid(
        newCheckInDash,
        DDMMYYYYDashFormat,
        newCheckOutDash,
        DDMMYYYYDashFormat,
      );
      if (newCheckInDash && newCheckOutDash && isCheckInCheckOutValid) {
        const newCheckIn = dateConvertAvailToProduct(newCheckInDash);
        const newCheckOut = dateConvertAvailToProduct(newCheckOutDash);
        const newDates = {
          ...beginEndDates,
          checkInDate: newCheckIn,
          checkOutDate: newCheckOut,
        };
        setBeginEndDates(newDates);
        setDateSelection(newCheckOutDash);
        // cm nights from url params
        const newCmNights = dateCalculateNights(newCheckIn, newCheckOut) || 1;
        setCmAdNights(Number.parseInt(newCmNights, 10));
        if (!isGift) {
          // get products
          getProducts(newCheckOutDash, newCheckIn, newCheckOut);
        }
      }
    }
  }, [isGoogleHotel, searchParams]);

  useEffect(() => {
    let message = '';
    const beginDate = beginEndDates?.checkInDate;
    const endDate = beginEndDates?.checkOutDate;
    if (beginDate && endDate && !selection) {
      message = CM_CHOOSE_PRODUCT;
    }
    if (beginDate && !endDate) {
      message = CM_CHOOSE_CHECKOUT_DATE;
    }
    if (!beginDate && !endDate) {
      message = CM_CHOOSE_DATES;
    }
    if (beginDate && endDate && selection) {
      message = '';
    }
    setDynamicTravelError(message);
  }, [beginEndDates, selection]);

  const onNext = () => {
    if (next) {
      setMonth(next.month);
      setYear(next.year);
    }
  };

  const onPrevious = () => {
    if (prev) {
      setMonth(prev.month);
      setYear(prev.year);
    }
  };

  const onHoverDate = (date) => {
    setCurrentHoverDate(date);
    setIsMouseLeftCalendar(false);
  };

  const onHoverOffCells = () => {
    setIsMouseLeftCalendar(true);
  };

  const shouldShowMainGiftButton = () => {
    return (
      deal?.giftable &&
      deal?.category?.canonicalPathType === 'travel' &&
      (isBookingCalendarOnRedemptionGift || isDynamicTravelDeal)
    );
  };

  const renderGiftButton = () => {
    if (shouldShowMainGiftButton()) {
      return mainDealGiftButton;
    }

    return (
      <DealGiftButton
        className={`${
          isExpressDealPage && selection
            ? `primary-button full-width outline express-gifting-text margin ${
                isNibbleAppeared ? 'top-margin' : ''
              }`
            : 'primary-button full-width outline gifting'
        }`}
        deal={buyButtonDeal}
        isValidExternal={isButtonClickValid}
        text={GIVE_AS_A_GIFT}
      />
    );
  };

  const renderCompliancetext = isExpressDealPage && selection !== null;

  if (isLightPage()) {
    return null;
  }

  return (
    <>
      {deal.depositAvailable && (
        <Message
          message={DEPOSIT_AVAILABLE(
            formatCurrency(deal.currency, deal.depositPrice, false, false),
          )}
          showIcon={false}
          type={MESSAGE_TYPES.success}
        />
      )}

      {isCYF && (
        <>
          <BookingCalendarStep title={CYF_BOOKING_STEP_ONE} />
          <BookingCalendarPassengers
            initialQuantity={initialQuantity}
            onQuantityChange={selectQuantity}
          />
          <BookingCalendarStep title={CYF_BOOKING_STEP_TWO} />
          <BookingCalendarAirports
            deal={deal}
            onAirportChange={selectAirport}
            setCurrentLondonAirports={setCurrentLondonAirports}
          />
          <BookingCalendarStep title={CYF_BOOKING_STEP_THREE} />
          <BookingCalendarNights deal={deal} onNightChange={selectNights} />
        </>
      )}

      {isDynamicTravelGift && (
        <>
          <BookingCalendarStep stepIndex="1" title={STEP_A} />
          {maxNights && (
            <ChannelManagerNights
              initialNights={cmAdNights}
              maxNights={maxNights}
              onNightChange={selectNights}
            />
          )}
        </>
      )}

      {isReadyForCalendar && !isDynamicTravelGift && (
        <>
          <BookingCalendarStep
            stepIndex={isDynamicTravelDeal ? '1' : null}
            title={STEP_A}
          >
            {!isDynamicTravelDeal && <BookingCalendarClear onClick={onReset} />}
          </BookingCalendarStep>
          {isModernVipVariant && (
            <div className="calendar-vip__social-cue">
              {VIP_CALENDAR_SOCIAL_CUE} <strong>{VIP_FIFTEEN_PERCENT}</strong>{' '}
              {VIP_CHECKOUT}
            </div>
          )}
          <BookingCalendar
            beginEndDates={beginEndDates}
            cells={cells}
            deal={deal}
            departureAirport={departureAirport}
            displayMonth={displayMonth}
            displayYear={displayYear}
            errorCYF={errorCells && isCYF}
            handleOnHoverDate={onHoverDate}
            handleOnHoverOffCells={onHoverOffCells}
            handleOnNext={onNext}
            handleOnPrevious={onPrevious}
            isCheckinNearMonthEnd={isCheckinNearMonthEnd}
            isReadyForCalendar={isReadyForCalendar}
            next={next}
            nights={nights}
            onSelect={selectDate}
            onSelectEndDate={selectEndDate}
            prev={prev}
            quantity={quantity}
            resetCalendar={onReset}
            selection={selection}
            thisDealLondonAirports={thisDealLondonAirports}
          />
        </>
      )}

      {!isDynamicTravelDeal && dateSelection && products && selection && (
        <>
          <Element name={CALENDAR_STEP_TWO} />
          <BookingCalendarStep title={STEP_B} />
          <BookingCalendarProducts
            currency={deal.currency}
            isCYF={isCYF}
            onQuantityChange={selectQuantity}
            onSelect={onSelectProduct}
            priceDiff={priceDiff}
            products={products}
            quantity={quantity}
            selection={selection}
          />
        </>
      )}

      {((isDynamicTravelDeal && dateSelection && roomOnly?.length <= 0) ||
        isDynamicTravelGift) &&
        packages?.length > 0 && (
          <>
            <Element name={CALENDAR_STEP_TWO} />
            <BookingCalendarStep stepIndex="2" title={STEP_B} />
            <BookingCalendarPackages
              currency={deal.currency}
              isDynamicTravelGift={isDynamicTravelGift}
              onQuantityChange={selectQuantity}
              onSelect={onSelectProduct}
              packages={packages}
              quantity={quantity}
              selection={selection}
            />
          </>
        )}

      {roomOnly?.length > 0 && dateSelection && !isDynamicTravelGift && (
        <>
          <Element name={CALENDAR_STEP_TWO} />
          <BookingCalendarStep stepIndex="2" title={STEP_B} />
          <Tab.Container
            activeKey={key}
            defaultActiveKey="roomonly"
            id="roomonly-packages"
            onSelect={(eventKey) => setRoomOnlyTab(eventKey)}
          >
            {showTabHeader && (
              <Nav className="roomonly-tabs" variant="tabs">
                <Nav.Item className="roomonly-tab">
                  <Nav.Link eventKey="roomonly">
                    <FontAwesomeIcon icon={faBed} />
                    &nbsp; Room
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="roomonly-tab-or">
                  <b>or</b>
                </Nav.Item>
                <Nav.Item className="roomonly-tab">
                  <Nav.Link eventKey="packages">
                    <FontAwesomeIcon icon={faUtensils} />
                    &nbsp; Room + Package
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            )}
            <Tab.Content>
              <Tab.Pane eventKey="roomonly">
                <>
                  {roomOnly?.length > 0 && (
                    <BookingCalendarRoomOnlyPackages
                      currency={deal.currency}
                      isDynamicTravelGift={isDynamicTravelGift}
                      onQuantityChange={selectQuantity}
                      onSelect={onSelectProduct}
                      packages={roomOnly}
                      quantity={quantity}
                      selection={selection}
                    />
                  )}
                </>
              </Tab.Pane>
              <Tab.Pane eventKey="packages">
                <>
                  {packages?.length > 0 && (
                    <BookingCalendarPackages
                      currency={deal.currency}
                      isDynamicTravelGift={isDynamicTravelGift}
                      onQuantityChange={selectQuantity}
                      onSelect={onSelectProduct}
                      packages={packages}
                      quantity={quantity}
                      resetPackage={key}
                      selection={selection}
                    />
                  )}
                </>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </>
      )}

      {!isCYF &&
        !isDynamicTravelDeal &&
        deal.depositAvailable &&
        dateSelection &&
        selection && (
          <>
            <BookingCalendarStep title={STEP_C} />
            <BookingCalendarPayments
              currency={deal.currency}
              depositPrice={selection.depositPrice}
              fullPrice={selection.price}
              onSelect={(value) => setDeposit(value)}
              selection={deposit}
            />
          </>
        )}
      {isCYF && flights && dateSelection && selection && (
        <>
          <BookingCalendarStep
            title={
              isEqual(flights, defaultFlights) ? STEP_C : CYF_BOOKING_STEP_SIX_A
            }
          >
            {!isEqual(flights, defaultFlights) && (
              <b>
                (
                <a
                  className="original-flight"
                  onClick={onChooseOriginalFlight}
                  onKeyDown={onChooseOriginalFlight}
                  role="button"
                  tabIndex={0}
                >
                  {USE_ORIGINAL_FLIGHT}
                </a>
                )
              </b>
            )}
          </BookingCalendarStep>
          <FlightPair flights={flights} />
          <BookingAlternativeFlights
            chooseFlight={onChooseFlight}
            date={dateSelection}
            departureAirport={departureAirport}
            inBoundDate={inBoundDate}
            priceDiff={priceDiff}
            productId={selection.dealVoucherProductId}
            selectedFlightPair={flights}
            thisDealLondonAirports={thisDealLondonAirports}
          />
          <BookingCalendarPrice
            price={Number.parseFloat(selection.price) + priceDiff}
          />
        </>
      )}
      {packages?.length === 0 && (
        <Message
          extraClasses="message-no-background message-center message-border-radius"
          message={isDynamicTravelGift ? NO_PRODUCTS_FOR_NIGHTS : NO_PRODUCTS}
          showIcon={false}
          type={MESSAGE_TYPES.error}
        />
      )}
      {error && !flightError && !isGift && (
        <>
          {!isDynamicTravelDeal && (
            <Message
              extraClasses="message-no-background message-center message-border-radius"
              message={CHOOSE_ARRIVAL}
              showIcon={false}
              type={MESSAGE_TYPES.error}
            />
          )}
          {isDynamicTravelDeal && (
            <Message
              extraClasses="message-no-background message-center message-border-radius"
              message={dynamicTravelError}
              showIcon={false}
              type={MESSAGE_TYPES.error}
            />
          )}
        </>
      )}
      {flightError && (
        <Message
          extraClasses="message-no-background message-center message-border-radius"
          message={FLIGHT_ERROR}
          showIcon={false}
          type={MESSAGE_TYPES.error}
        />
      )}

      <CalendarSocialCue deal={deal} />
      {isDynamicTravelGift && (
        <>
          <Message iconPosition="left" message={BCOR_GIFT_MESSAGE} showIcon />
        </>
      )}
      {/* modal-sticky */}
      <div className="modal-sticky">
        {isTravel
          ? TravelCalendarBuyButtons({
              buttonRef,
              buyButtonDeal,
              deal,
              deposit,
              isBookingCalendarOnRedemptionGift,
              isButtonClickValid,
              isGiftable: deal.giftable,
              isGoogleHotel,
              searchParams,
              selectedProductId: selection?.dealVoucherProductId,
            })
          : CalendarBuyButtons({
              buyButton,
              buyButtonDeal,
              deal,
              deposit,
              isButtonClickValid,
              isExpressDealPage,
              isGift,
              isNibbleAppeared,
              paymentData,
              selectedProductId: selection?.dealVoucherProductId,
              selection,
              setIsNibbleAppeared,
            })}
        {isMobile &&
          (!isModal
            ? renderGiftButton()
            : isExpressDealPage &&
              !isAuthenticated &&
              (selection !== null || dateSelection !== null)
            ? null
            : renderGiftButton())}

        {isMobile && renderCompliancetext && (
          <ExpressCheckoutText
            isAuthenticated={isAuthenticated}
            isMobile={isMobile}
            margin={isAuthenticated ? '-8px 0px 0px 0px' : '-10px 0px 0px 0px'}
            paddingTop="3px"
            shouldRenderComplianceText={renderCompliancetext}
          />
        )}
      </div>
      {isDynamicTravelGift && <BasketSocialCues />}

      <style jsx>{`
        .original-flight {
          color: ${theme.colors.primary};
        }
        .calendar-vip__social-cue {
          padding: 8px 10px;
          border-radius: 4px;
          background-color: ${theme.colors.vipinfobg};
          margin-bottom: 12px;
          color: ${theme.colors.vipinfotext};
        }
        :global(.roomonly-tabs) {
          margin-bottom: 20px;
        }
        :global(.roomonly-tab) {
          flex: 1 1 auto;
        }
        :global(.roomonly-tab-or) {
          line-height: 30px;
          margin: 0 10px;
        }
        :global(.nav-tabs .nav-link) {
          border-bottom: 2px solid #aeaeae;
          margin: 0;
          text-align: center;
        }
        :global(.nav-tabs .nav-link.active) {
          border-bottom: 2px solid ${theme.colors.primary};
          color: ${theme.colors.primary};
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .modal-sticky {
            position: sticky;
            bottom: 0;
            z-index: ${isExpressDealPage ? '999999' : '10'};
            background-color: ${isExpressDealPage ? '#ffffff' : ''};
          }
        }
      `}</style>
    </>
  );
};

CalendarContainer.propTypes = {
  buttonRef: PropTypes.any,
  deal: PropTypes.object.isRequired,
  isCYF: PropTypes.bool.isRequired,
  isDynamicTravelDeal: PropTypes.bool,
  isGift: PropTypes.bool,
  isGoogleHotel: PropTypes.bool,
  isModal: PropTypes.bool,
  isModernVipVariant: PropTypes.bool,
  isTravel: PropTypes.bool,
  mainDealGiftButton: PropTypes.elementType,
  searchParams: PropTypes.object,
  setIsCYOSelected: PropTypes.func,
  setIsOptionSelected: PropTypes.func,
};

export default CalendarContainer;
